/**
 * What renders while a route's loaders are still running.
 *
 * This is a SKELETON shaped like the content that
 * is coming, not a spinner covering a screen. The shell around it (header,
 * wordmark, sign-out) is already painted, so a fan sees the app respond
 * immediately and only the part that is genuinely unknown is greyed.
 */
import { Skeleton } from "@sportsmet/ui";
import type { ReactNode } from "react";

export const RoutePendingScreen = (): ReactNode => (
  <div className="flex flex-col gap-4">
    <Skeleton shape="title" width="w-48" label="Loading this screen" />
    <Skeleton shape="card" />
    <Skeleton shape="card" />
  </div>
);
